<template>
    <div v-if="data" class="paddingh20 paddingt20 bordert marginb10 bg-white">
        <div class="flex-container left borderb paddingb20 vfull">
            <div class="ratio-container marginr20" style="width:50px;height:50px">
                <div class="img-container">
                    <img :src="data.itemUrl" alt="">
                </div>
            </div>
            <div class="flex1 flex-container-col hfull">
                <div class="flex-container">
                    <div :id="'score'+data.itemScore">
                        <label class="score marginr20 float-right" v-for="item in data.itemScore"></label>
                    </div>
                    <i class="icon icon-order_invisible" v-if="data.state==3||data.state==4" style="font-size: 20px;"></i>
                    <i class="icon icon-more" v-else style="font-size: 24px;" @click="pinglunMore(data)"></i>
                </div>

                <div class="flex-container text-light fs-12">
                    <span>{{data.skuStr}}</span>
                    <span>{{data.timeStr}}</span>
                </div>
            </div>
        </div>







        <p class="paddingv10">{{data.content}}</p>

        <div class="paddingb20 bg-white" v-if="data.imageUrls.length">
            <cmui-list :col="3" :space="10" :border="true">
                <cmui-list-item v-for="item in data.imageUrls">
                    <div class="ratio-container" style="background: url({{item.imageUrl}}) center center / cover no-repeat;">
                        <!--<div class="img-container center">-->
                        <cmui-img  :pre-view="true" :pre-view-list="preViewList" :pre-view-index="$index"></cmui-img>
                        <!--</div>-->
                    </div>
                </cmui-list-item>
            </cmui-list>
        </div>



        <div class="padding10" style="background-color: #FAFAFA;    word-break: break-all;" v-if="data.reply">
            {{data.reply}}
        </div>

        <div class="fixed-bottom padding20 text-white" v-if="imageInfo" style="z-index: 9999999999">
            {{imageInfo}}
        </div>
    </div>
</template>
<style lang="scss">
    input[type="radio"]{
        display: none;
    }
    .score{
        display: inline-block;
        height: 20px;
        width: 20px;
        background-image: url("//image1.51tiangou.com/tgou2/img2/product/ico-score0.png");
        -webkit-background-size: 100%;
        background-size: 100%;
    }
    #score1>.score{
        background-image: url("//image1.51tiangou.com/tgou2/img2/product/ico-score1.png");
    }
    #score2>.score{
        background-image: url("//image1.51tiangou.com/tgou2/img2/product/ico-score2.png");
    }
    #score3>.score{
        background-image: url("//image1.51tiangou.com/tgou2/img2/product/ico-score3.png");
    }
    #score4>.score{
        background-image: url("//image1.51tiangou.com/tgou2/img2/product/ico-score4.png");
    }
    #score5>.score{
        background-image: url("//image1.51tiangou.com/tgou2/img2/product/ico-score5.png");
    }
</style>
<script>
    import discoverService from 'javascript/libs/tg/api/discover.js';
    export default {
        name: "item",
        data(){
            return {
                imageInfo:''
            }
        },
        props:{
            data:{type:Object,default:null}
        },
        computed:{
            preViewList(){
                return _.map(this.data.imageUrls,item=>item.imageUrl);
            }
        },
        events:{
            preView(value){
                if(value){
                    this.imageInfo=this.data.content;
                }else{
                    this.imageInfo='';
                }
            }
        },
        methods:{
            pinglunMore(data){
                let _this=this;
                maple.actions({buttons:[{text:'隐藏评论',fn(){
                    maple.confirm({
                        content: '确认隐藏评价吗？隐藏后将不会在商品评价中展示。'
                        , okFn: function(){
                            discoverService.hideEvaluation({
                                data:{
                                    evaluationId:data.id
                                },
                                success(data){
                                    maple.notice('隐藏成功');
                                    _this.data.state=3;
                                }
                            })
                        }
                    });
                }}]});
            }
        }
    }
</script>